/**
 * Channel count limits and defaults for plan selection.
 */
export const CHANNEL_LIMITS = {
  min: 1,
  default: 3,
}

export const FREE_PLAN_CHANNEL_LIMIT = 3
export const AGENCY_PLAN_CHANNEL_MINIMUM = 10

/**
 * Number of free months saved when choosing yearly billing.
 */
export const YEARLY_SAVINGS_MONTHS = 2
